import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from '@mgc/react-components/lib/Progress';
import strings from '../../../strings';

class Progress extends Component {
    static propTypes = {
        complete: PropTypes.bool.isRequired,
        failed: PropTypes.bool.isRequired,
        isSuccessful: PropTypes.bool.isRequired,
        openHelp: PropTypes.func.isRequired,
    };

    _getLabel() {
        if (this.props.failed) {
            return strings.orderFailed;
        }
        if (this.props.isSuccessful) {
            return strings.orderSubmitted;
        }
        return strings.submittingOrder;
    }

    _getHelpPrompt() {
        if (this.props.failed) {
            return (
                <a
                    className="cursor-pointer"
                    onClick={() => this.props.openHelp()}
                >
                    {strings.orderHelp}
                </a>
            );
        }
        return '';
    }

    _getStatus() {
        if (this.props.failed) {
            return 'danger';
        }
        if (this.props.isSuccessful) {
            return 'success';
        }
        return 'info';
    }

    render() {
        return (
            <div>
                <div>
                    <strong>{this._getLabel()}</strong>
                </div>
                <div className="m-b-sm">
                    <small>{this._getHelpPrompt()}</small>
                </div>
                <ProgressBar
                    progress={100}
                    striped={true}
                    animated={!this.props.complete}
                    status={this._getStatus()}
                />
            </div>
        );
    }
}

export default Progress;



// WEBPACK FOOTER //
// ./app/components/Modals/ShoppingCartModal/Progress.jsx